import * as Sentry from '@sentry/browser';

const initSentry = () => {
  if (
    import.meta.env.VITE_ENVIRONMENT &&
    ['dev', 'production'].includes(import.meta.env.VITE_ENVIRONMENT)
  ) {
    Sentry.init({
      dsn: `https://5f1afe75b94a4c3432ea69fb4a329f0f@o4508172385976320.ingest.de.sentry.io/4508263161528400`,
      environment: import.meta.env.VITE_ENVIRONMENT,
      ignoreErrors: ['shadowRoot'],
      beforeSend: event => {
        if (event.exception) {
          // Analyze the stack trace
          const originatesFromParent = event.exception.values?.some(value =>
            value.stacktrace?.frames?.some(
              frame => frame.filename && !frame.filename.startsWith(window.location.origin)
            )
          );

          if (originatesFromParent) {
            return null; // Ignore errors not originating from your widget
          }
        }
        return event; // Log errors originating from your widget
      }
    });
  }
};

const setSentryScope = ({ user, lang }: UrlParams) => {
  Sentry.configureScope(scope => {
    if (user) {
      scope.setUser({
        user
      });
    }

    scope.setExtra('lang', lang);
  });
};

export { initSentry, setSentryScope };
